import classNames from "classnames";
import React, { Dispatch, SetStateAction } from "react";

import { Keyboard } from "../Keyboard";
import OkButton from "../OkButton/OkButton";
import { NumPadKeyboardLayout } from "./NumPadKeyboardLayout";

// tslint:disable-next-line:no-var-requires
const style = require("./NumPadView.scss");

export interface NumPadViewProps {
    submit: (e: React.BaseSyntheticEvent | string) => void;
}

// tslint:disable:jsx-no-lambda
const NumPadView = (props: NumPadViewProps) => {
    const [data, setData] = React.useState("");
    const input = React.createRef<HTMLInputElement>();
    return (
        <>
            <div className={classNames(style.wrapper)}>
                <div className={classNames(style.inputBackground)}>
                    <input
                        value={data}
                        onChange={e => setDataWithValidation(e, setData)}
                        ref={input}
                    />
                </div>
                <Keyboard input={input}>
                    <NumPadKeyboardLayout />
                </Keyboard>
                <OkButton
                    className={classNames(style.okBtn, style.btn)}
                    click={() => props.submit(data)}
                />
            </div>
        </>
    );
};

const setDataWithValidation = (
    e: React.BaseSyntheticEvent,
    setData: Dispatch<SetStateAction<string>>
) => {
    const regExp = /^(\d{0,9}[.|,]?(?:\d{1,2})?)$/;
    if (regExp.test(e.target.value)) {
        setData(e.target.value);
    }
};

export default NumPadView;
